import { render, staticRenderFns } from "./equipment-caract-modal.vue?vue&type=template&id=01c7fb80&scoped=true&"
import script from "./equipment-caract-modal.vue?vue&type=script&lang=ts&"
export * from "./equipment-caract-modal.vue?vue&type=script&lang=ts&"
import style0 from "./equipment-caract-modal.vue?vue&type=style&index=0&id=01c7fb80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c7fb80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDialog,VIcon,VRow})
